import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/change-requests/constants';

export const columnCriteriaStripeData: {caption: string, type: ColumnTypes}[] = [
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_TYPE], type: ColumnTypes.EVENT_TYPE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_SOURCE], type: ColumnTypes.EVENT_SOURCE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_CODE], type: ColumnTypes.EVENT_CODE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_DESCRIPTION], type: ColumnTypes.EVENT_DESCRIPTION},
    {caption: COLUMN_CAPTIONS[ColumnTypes.AUTHOR], type: ColumnTypes.AUTHOR},
    {caption: COLUMN_CAPTIONS[ColumnTypes.STATUS], type: ColumnTypes.STATUS},
];

export const dateCriteriaStripeData: {caption: string, type: ColumnTypes, key: 'from' | 'to'}[] = [
    {caption: 'Last Updated From', type: ColumnTypes.LAST_UPDATED, key: 'from'},
    {caption: 'Last Updated To', type: ColumnTypes.LAST_UPDATED, key: 'to'},
    {caption: 'Due Date From', type: ColumnTypes.DUE_DATE, key: 'from'},
    {caption: 'Due Date To', type: ColumnTypes.DUE_DATE, key: 'to'},
];
